var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWordCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7054 4.48765C12.9641 4.17746 12.9396 3.70088 12.6506 3.42317C12.3616 3.14546 11.9176 3.17179 11.6589 3.48197L8.50378 7.26445C7.86446 8.03089 7.43392 8.54434 7.06582 8.87642C6.71516 9.19277 6.5092 9.26173 6.32928 9.26173C6.14936 9.26173 5.9434 9.19277 5.59274 8.87642C5.22464 8.54434 4.7941 8.03089 4.15479 7.26444L3.34085 6.28865C3.08211 5.97847 2.63809 5.95214 2.3491 6.22985C2.06011 6.50756 2.03558 6.98414 2.29431 7.29432L3.14303 8.31181C3.73847 9.0257 4.23513 9.62117 4.68894 10.0306C5.16901 10.4637 5.68681 10.7694 6.32928 10.7694C6.97176 10.7694 7.48956 10.4637 7.96962 10.0306C8.42343 9.62117 8.92009 9.02571 9.51553 8.31181L12.7054 4.48765Z",
    fill: "#828D99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordCheck);
export default __webpack_public_path__ + "static/media/word-check.bd94b411442eacc4f451658397b832e5.svg";
export { ForwardRef as ReactComponent };